<template>
    <div>
        <v-list>
            <v-list-item 
                v-for="(option, index) in options" 
                :key="index"
                :exact="true"
                :to="{ name: option.route }"
                @click="$emit('option-clicked')">
                <v-list-item-icon>
                    <v-icon color="ddwhite">{{ option.icon }}</v-icon>
                </v-list-item-icon>
                <span class="text-decoration-none ddwhite--text">
                    {{ option.text }}
                </span>
            </v-list-item>
        </v-list>

        <v-divider/>

        <v-list>
            <v-list-item  @click="logOut">
                <v-list-item-icon>
                    <v-icon color="ddwhite">mdi-power</v-icon>
                </v-list-item-icon>
                <span class="text-decoration-none ddwhite--text">
                    {{ $t("components.UserAccount.LogoutLabel") }}
                </span>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import AuthAPI from '@/utils/AuthAPI';
import EventBus from '@/utils/EventBus';

/**
 * MainMenu component includes the menu links that the current user could access.
 * It also includes a logout button. It uses AuthAPI class to check the role of 
 * the current user and to perform the logout process, and also uses the 
 * EventBus class to show user messages.
 */
export default {
    name: 'MainMenu',
    data: () => ({
        options: [],
        admin: false
    }),
    async mounted() {
        const [ success, admin ] = await AuthAPI.imAdmin();
        if (!success) this.$router.push({ name: 'login' });
        else this.admin = admin;

        this.inflateMenu();
    },
    methods: {
        inflateMenu() {
            const $t = this.$t.bind(this);

            this.options = [
                {
                    icon: 'mdi-view-dashboard',
                    text: $t("components.MainMenu.DashboardLink"),
                    route: 'dashboard'
                },
                {
                    icon: 'mdi-account',
                    text: $t("components.MainMenu.ProfileLink"),
                    route: 'profile'
                }
            ]

            if (this.admin) this.options.push({
                icon: 'mdi-account-group',
                text: $t("components.MainMenu.CustomersLink"),
                route: 'customers'
            });
        },
        async logOut() {
            const [ success, error ] = await AuthAPI.logOut();
            if (!success) EventBus.$emit("popup", error.message);
            if(this.$intercom)
              this.$intercom.shutdown();
            else EventBus.$emit("popup", `Goodbye!`);
            this.$router.push({ name: 'login' });
        }
    }
}
</script>